import { shouldApplySst, sstAmount } from "../../helpers/sst";

const currencySymbol =
    process.env.REACT_APP_COUNTRY === "SINGAPORE" ? "$" : "RM";

const numberFormatter = new Intl.NumberFormat("en-GB", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

export default function SstIncludedField({
    sstIncluded,
    onChange,
    afterDiscount = 0,
    commenceDate,
}) {
    const included = sstIncluded === true;
    const taxActive = shouldApplySst(commenceDate, included);
    const taxValue = sstAmount(afterDiscount, commenceDate, included);

    return (
        <div className="sstIncludedField">
            <div className="sstIncludedCard">
                <div className="sstIncludedHeader">
                    <span className="sstIncludedTitle">SST Included</span>
                    <span className="sstIncludedBadge">8%</span>
                </div>
                <p className="sstIncludedHint">
                    When enabled, 8% SST is added to order totals and customer
                    invoices.
                </p>
                <div
                    className="sstSegment"
                    role="group"
                    aria-label="SST Included"
                >
                    <button
                        type="button"
                        className={`sstSegmentBtn ${included ? "active yes" : ""}`}
                        onClick={() => onChange(true)}
                        aria-pressed={included}
                    >
                        Yes
                    </button>
                    <button
                        type="button"
                        className={`sstSegmentBtn ${!included ? "active no" : ""}`}
                        onClick={() => onChange(false)}
                        aria-pressed={!included}
                    >
                        No
                    </button>
                </div>
                {included && (
                    <div
                        className={`sstIncludedStatus ${taxActive ? "on" : "muted"}`}
                    >
                        {taxActive ? (
                            <>
                                Estimated SST on net amount:{" "}
                                <strong>
                                    {currencySymbol}{" "}
                                    {numberFormatter.format(taxValue)}
                                </strong>
                            </>
                        ) : (
                            <>
                                SST is enabled; not applied for orders with
                                commence date before 27 Jul 2026.
                            </>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}

export function CartSstLine({ sstIncluded, afterDiscount, commenceDate }) {
    if (sstIncluded !== true) return null;
    const taxValue = sstAmount(afterDiscount, commenceDate, true);
    if (taxValue <= 0) return null;

    return (
        <div className="summary sstSummaryLine">
            <div className="summarysubtotal">SST (8%)</div>
            <div className="summarysubtotal sstSummaryAmount">
                {currencySymbol} {numberFormatter.format(taxValue)}
            </div>
        </div>
    );
}
